import React from 'react'
import { formatNumberWithCommas } from '../constants/commonFunction'

const TierCard = ({totalPoints,redemPoints, availablePoints,nextTarget,tierName,tierStar,awardCup}) => {
  return (
    <>
        <div className='tierCardBg'>
            <div style={{display: "flex", justifyContent: "center"}}> 
                <img src={tierStar} alt="awardStar" className='awardStar'/>
                </div>
                <div className='tierName'><span>{tierName} Tier <img src={awardCup} alt='cup'/></span></div>
                <div className='tierCardDetails'>
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(totalPoints)}</p>
                        <p className='smallText'>Total Points</p>

                    </div>
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(redemPoints)}</p>
                        <p className='smallText'>Redeemed Points</p>

                    </div>
                    <div />
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(availablePoints)}</p>
                        <p className='smallText'>Available Points</p>

                    </div>

                    
                    {/* <div className='tierDetails'>
                        <p>{nextTarget}</p>
                        <p className='smallText'>Next Target Points</p>

                    </div> */}
                </div>

                {/* <div className='tierCardDetails'>
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(totalPoints)}</p>
                        <p className='smallText'>TDS Points</p>

                    </div>
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(redemPoints)}</p>
                        <p className='smallText'>Bonus Points</p>

                    </div>
                    <div className='tierDetails'>
                        <p>{formatNumberWithCommas(availablePoints)}</p>
                        <p className='smallText'>Cooling Points</p>

                    </div>
                </div> */}
        </div>
    </>
  )
}

export default TierCard